import React from "react";
import { Link } from "react-router-dom";
import { Radar } from "lucide-react";
import AskSusan from "./AskSusan";

export const SrLogo = ({ light }) => (
  <div className="sr-logo" style={light ? { color: "#fff" } : {}}>
    <span className="sr-logo-mark"><Radar size={20} /></span>
    SmartReach<span style={{ color: "var(--gold)" }}>AI</span>
  </div>
);

const NAV = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/solutions/restaurants", label: "Solutions" },
  { to: "/competitor-targeting", label: "Competitor Targeting" },
  { to: "/visit-intelligence", label: "Visit Intelligence" },
  { to: "/comparison", label: "Compare" },
  { to: "/pricing", label: "Pricing" },
];

export const SrHeader = () => (
  <header className="sr-header">
    <div className="sr-wrap sr-header-inner">
      <Link to="/" data-testid="sr-home-logo"><SrLogo /></Link>
      <nav className="sr-nav-links">
        {NAV.map((n) => (
          <Link key={n.to} to={n.to} className="sr-navlink" data-testid={`sr-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{n.label}</Link>
        ))}
        <Link to="/?view=new" className="sr-navlink sr-viewtoggle" data-testid="nav-view-new">New design</Link>
      </nav>
      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <Link to="/login" className="sr-btn sr-btn-ghost sr-btn-sm" data-testid="sr-login-btn">Log in</Link>
        <Link to="/signup" className="sr-btn sr-btn-primary sr-btn-sm" data-testid="sr-signup-btn">Get started</Link>
      </div>
    </div>
  </header>
);

export const SrFooter = () => (
  <footer className="sr-footer">
    <div className="sr-wrap" style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr 1fr", gap: 32 }}>
      <div>
        <SrLogo light />
        <p style={{ color: "#8ea1c4", marginTop: 12, fontSize: 14, maxWidth: 280 }}>
          Turn local attention into measurable visits, leads, bookings, sales, and repeat customers.
        </p>
        <p style={{ color: "#6f83a8", marginTop: 16, fontSize: 12 }}>by FunAsia Digital</p>
        <p style={{ color: "#6f83a8", fontSize: 12 }}>Concept & design: FunAsia Digital with Auxano</p>
      </div>
      <div>
        <h4>Product</h4>
        <Link to="/how-it-works">How it works</Link>
        <Link to="/competitor-targeting">Competitor Targeting</Link>
        <Link to="/visit-intelligence">Visit Intelligence</Link>
        <Link to="/radio-digital">Radio + Digital</Link>
      </div>
      <div>
        <h4>Solutions</h4>
        <Link to="/solutions/restaurants">Restaurants</Link>
        <Link to="/solutions/retail">Retail</Link>
        <Link to="/solutions/auto">Auto</Link>
        <Link to="/professional-service">Professional Service</Link>
      </div>
      <div>
        <h4>Company</h4>
        <Link to="/pricing">Pricing</Link>
        <Link to="/comparison">Comparison</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/?view=new" data-testid="footer-view-new">View new homepage</Link>
      </div>
    </div>
    <div className="sr-wrap" style={{ marginTop: 36, borderTop: "1px solid rgba(255,255,255,.1)", paddingTop: 20, fontSize: 12, color: "#6f83a8" }}>
      © {new Date().getFullYear()} SmartReachAI · by FunAsia Digital.
    </div>
  </footer>
);

export const MarketingPage = ({ children }) => (
  <div className="sr-root">
    <SrHeader />
    {children}
    <SrFooter />
    <AskSusan />
  </div>
);
